/**
 * Decode a prefill token (JWT) client-side.
 * Only does base64 decode — actual signature validation happens server-side
 * when the booking is submitted.
 */
export function decodePrefillToken(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    // JWT uses base64url encoding (- instead of +, _ instead of /)
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad) base64 += '='.repeat(4 - pad);
    const payload = JSON.parse(atob(base64));

    // Check expiry
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      return null;
    }

    // Must be a prefill token
    if (payload.type !== 'prefill' || !payload.data) {
      return null;
    }

    return payload.data;
  } catch {
    return null;
  }
}

const API_BASE = process.env.REACT_APP_API_URL || '';

function getAuthHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  const token = localStorage.getItem('nordic_auth_token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

/**
 * Parse a raw email via the backend and get a prefill token + URL.
 */
export async function parseEmail(rawEmail) {
  const response = await fetch(`${API_BASE}/api/email/parse`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ rawEmail }),
  });

  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.error || 'Failed to parse email');
    error.status = response.status;
    throw error;
  }

  return data;
}
